import { KEY_USER_INFO, KEY_SESSION_INFO } from '@/api/config'
import paramsData from '@/api/params/params-wrap'
import userApi from '@/api/modules/api-user'
import storage from '@/utils/storage'
import * as types from './mutation-types'

// 初始化数据 --> mapStates
const state = ()=>({
  showCaptcha: false,
  userInfo: storage.get(KEY_USER_INFO),
  userSessionInfo: storage.get(KEY_SESSION_INFO)
})

// 衍生数据，追踪数据更新后值 --> mapGetters
const getters = {
  showCaptcha: state => state.showCaptcha,
  userInfo: state => state.userInfo,
  userSessionInfo: state => state.userSessionInfo
}

// mutations，同步数据，vue视图文件中可用this.$store.commit
const mutations = {
  [types.SHOW_CAPTACH](state, payload) {
    state.showCaptcha = payload.status
  },

  [types.SET_USER_INFO](state, payload) {
    const { result = {} } = payload
    const obj = { sessionId: result.sessionId }
    state.userInfo = result
    state.userSessionInfo = obj
    storage.set(KEY_USER_INFO, result)
    storage.set(KEY_SESSION_INFO, obj)
  }
}

// actions， 异步操作数据，vue视图文件中可用this.$store.dispatch
const actions = {

  /**
   * 获取用户所在IP
   */
  getIpAddr() {
    return new Promise((resolve) => {
      userApi.getIpAddr()
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          console.log(err)
        })
    })
  },
  /**
   * 登录检测
   */
  checkLogin(_, params) {
    return new Promise((resolve, reject) => {
      userApi.checkLogin(params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /**
   * H5登录
   */
  login({ commit }, params) {
    return new Promise((resolve, reject) => {
      userApi.login(params)
        .then(res => {
          commit(types.SET_USER_INFO, { result: res })
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /**
   * APP内模拟登录 --> 直接获取用户信息
   */
  appLogin({ commit }, params) {
    return new Promise((resolve) => {
      commit(types.SET_USER_INFO, { result: params })
      resolve()
    })
  },

  /**
   * 登出 --> 后台
   */
  logout(_, params) {
    return new Promise((resolve) => {
      userApi.logout(params)
        .then(res => {
          // 清除本地缓存
          storage.clear()
          resolve(res)
        })
        .catch(err => {
          console.log(err)
        })
    })
  },
  /**
   * 登出 --> 前端
   */
  fedLogout() {
    return new Promise(resolve => {
      // 清除本地缓存
      storage.clear()
      resolve()
    })
  },

  /**
   * 发送短信验证码
   */
  sendCode(_, params) {
    return new Promise((resolve, reject) => {
      userApi.sendCode(params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /**
   * 是否需要图形验证码
   */
  needCaptcha({ commit }, params) {
    return new Promise((resolve) => {
      userApi.needCaptcha(params)
        .then(res => {
          commit(types.SHOW_CAPTACH, { status: res })
          resolve(res)
        })
        .catch(err => {
          console.log(err)
        })
    })
  },
  /**
   * 注册
   */
  register(_, params) {
    return new Promise((resolve) => {
      userApi.register(params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          console.log(err)
        })
    })
  },
  /**
   * 检查手机号码是否可用
   */
  checkMobile(_, params) {
    return new Promise((resolve) => {
      userApi.checkMobile(params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          console.log(err)
        })
    })
  },
  /**
   * 检查验证码是否可用
   */
  checkCode(_, params) {
    return new Promise((resolve) => {
      userApi.checkCode(params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          console.log(err)
        })
    })
  },
  /**
   * 更换手机
   */
  updateMobile(_, params) {
    return new Promise((resolve) => {
      userApi.updateMobile(paramsData.CHECK(params))
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          console.log(err)
        })
    })
  },
  /**
   * 修改登录密码
   */
  updatePassword(_, params) {
    return new Promise((resolve) => {
      userApi.updatePassword(params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          console.log(err)
        })
    })
  },
  /**
   * 修改交易密码
   */
  updateTradePassword(_, params) {
    return new Promise((resolve) => {
      userApi.updateTradePassword(params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          console.log(err)
        })
    })
  },
  /**
   * 获取用户渠道类别
   */
  getUserType(_, params) {
    return new Promise((resolve) => {
      userApi.getUserType(params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          console.log(err)
        })
    })
  },
  /**
   * 重置登录密码
   */
  resetPassword(_, params) {
    return new Promise((resolve) => {
      userApi.resetPassword(params)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          console.log(err)
        })
    })
  }
}

export default {
  namespaced:true,
  state,
  getters,
  mutations,
  actions
}